function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    var expires = "expires=" + d.toGMTString();
    console.log(expires);
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

$("#review").removeClass('show');
var popevent = getCookie("reviewPopupClose");
if (popevent != "" ) {
    //console.log("testing1");
} else {
    var frontrevpop = window.localStorage.getItem("newfrontpopreviews");
    if (frontrevpop != null && frontrevpop != '') {
        //console.log('review populate');
        var POPArray = JSON.parse(frontrevpop);
        var i = 0;
        setInterval(function () {
            var popevent21 = getCookie("reviewPopupClose");

            if (popevent21 != "") {

                //console.log("testing1");

            } else {
                var e = POPArray[i].comment;
                e = e.replace(";", "");
                var a = POPArray[i].post_date,
                    m = POPArray[i].Country_Name,
                    s = POPArray[i].Subject_Title,
                    r = POPArray[i].Student_Id,
                    c = Math.round(POPArray[i].pages),
                    ded = POPArray[i].deadline,
                    ot = POPArray[i].OType;
                var wordcnt = c + ' Pages ';
                POPArray[i].rating;
                m = (m = m.replace('"', ""))
                    .replace('"', ""), s = (s = s.replace('"', ""))
                    .replace('"', ""), r = (r = r.replace('"', ""))
                    .replace('"', ""), a = (a = a.replace('"', ""))
                    .replace('"', ""), e = (e = (e = e.replace('"', ""))
                        .replace('"', ""))
                    .replace(/(\\r\\n|\\n|\\r)/gm, ""), s.length > 20 ? $("#mahreviewssubject")
                    .html(s.substring(0, 20) + "...") : $("#mahreviewssubject")
                    .html(s), $("#mahreviewscomment")
                    .html(e), $("#mahreviewotype")
                    .html(ot), $("#mahreviewdeadline")
                    .html(ded), $("#mahreviewwordcnt")
                    .html(wordcnt), $("#mahreviewsuser")
                    .html("User:" + r), $("#mahreviewsdate")
                    .html(a), "Australia" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/aus-flag.svg' alt='country'/>"),"Canada"==m && $("#mahreviewsimages").html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/ca-flag.svg' alt='country'/>"), "India" == m && $("#mahreviewsimages")
                    .html("https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/ind-flag.svg' alt='country'/>"), "United States" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/us-flag.svg' alt='country'/>"), "New Zealand" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/nz-flag.svg' alt='country'/>"), "United Arab Emirates" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/uae-flag.svg' alt='country'/>"), "United Kingdom" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/uk-flag.svg' alt='country'/>"), "Malaysia" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/mal-flag.svg' alt='country'/>"), "Singapore" == m && $("#mahreviewsimages")
                    .html("<img src='https://cdn1.myassignmenthelp.store/lazyload-assets/ukpage/sg-flag.svg' alt='country'/>"), "19" == ++i && (i = 0)
                //$("#review").show('slow');
                $("#review").addClass('show');
            }
        }, 25500);
        setInterval(function () {
            $("#review").removeClass('show');
        }, 24500);
    }
}

$("#closeBtn").click(function (event) {
    setCookie("reviewPopupClose", 1, 1);
    $("#review").removeClass('show'); //OR fadeOut('10000') time is in milliseconds
});

var selectOpened = false;
setTimeout(function () {
    $('body').on("mouseleave", function (e) {
        //console.log("pop up issue");
        if (!selectOpened) {
            var user = getCookie("leavePopupCookie");
            if (user != "") {

            } else {
                if (!$('#callbackModal').is(':visible') && !$('#callbackModalSuccess').is(':visible') && !$('#login').is(':visible') && !$('#signuppopup').is(':visible') && !$('#forgot').is(':visible') ) {
                    if (!$('#wait-popup').is(':visible')) {
                        $("#wait-popup").modal("show");
                    }
                }
            }
        }
    });
}, 15000);

function hideLeavePopup() {
    setCookie("leavePopupCookie", 1, 1);
    $("#wait-popup").modal("hide");
}

window.setCookie = setCookie;
window.getCookie = getCookie;
window.hideLeavePopup = hideLeavePopup;
